import React from 'react';
import S from './Field.styles';
const Field = ({ className, children, ...otherProps }) => {
    return (React.createElement(S.Field, { className: className, ...otherProps }, children));
};
export default Field;
